import { useMemo } from "react";
import { PreviewDocument } from "views/UIelems/PreviewDocument";
import API_service from "xAppLib/providers/API_service";
import group_by_val_obj from "xAppLib/helpers/group_by_val_obj";
import ConsentQuestions from "./ConsentQuestions";
import { Divider, Message } from "semantic-ui-react";

export function consentFileUrl(consentFileName) {
	return API_service.API_BASE_URL + `cosmetics/treatments/forms/${encodeURIComponent(consentFileName)}`;
}


export function InformedConsent(props) {
	const { Section, enabled, visible, selectedProducts, availableProducts, displayPrefillWarning} = props;

	const consents = Object.entries(selectedProducts ?? {})
		.map(([mid, med]) => ({
			filename: med.xtra?.consent,
			group: availableProducts.find(p => p.mid === mid)?.path ?? "Other",
		}))
		.filter(v => v.filename)
		.concat({
			filename: "photography",
			group: "Photography / Images",
		})
		.concat({
			filename: "Financial Consent",
			group: "Financial Consent",
		});

	const grouped = group_by_val_obj(consents, v => v.group + v.filename) ?? {};
	const categories = useMemo(() => Object.values(grouped).map(g => g[0].group), [JSON.stringify(grouped)]);

	if (!(visible && enabled)) {
		return null;
	}

	return (
		<Section>
			<Section.Header small>Patient Consent to Treatment</Section.Header>
			<Section.Content>
				{displayPrefillWarning && (
					<Message warning icon="exclamation triangle" visible>
						<Message.Content>
							<Message.Header>Consent answers pre-filled</Message.Header>
							Your consent responses have been pre-filled from your previous visit. Please carefully review
							each item below and confirm your answers are still correct and current before submitting.
						</Message.Content>
					</Message>
				)}
				<ConsentQuestions {...props} categories={categories} />
				<Divider />
				<p className="text-sm text-is-black-50">
					You can view and download the consent forms for the treatments you have selected below. A copy of
					these consent forms will be sent to the email address you provide above for the treatments approved
					by the doctor.
				</p>
				
				<div className="flex-vertical space-y-2">
					{Object.keys(grouped)
						.sort()
						.map(group => (
							<PreviewConsentForm
								key={group}
								filename={grouped[group][0].filename}
								doc_name={grouped[group][0].group}
							/>
						))}
				</div>
			</Section.Content>
		</Section>
	);
}

export function PreviewConsentForm({ filename, doc_name = filename, children = doc_name, trigger }) {
	return (
		<PreviewDocument
			className="text-icosm-primary underline"
			viewOnly
			trigger={trigger}
			doc_name={doc_name}
			url={consentFileUrl(filename)}
		>
			{children}
		</PreviewDocument>
	);
}
